import React, { useState } from 'react';
import { Menu } from '@mui/material';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
  MoreButton,
  ShowDecimalsContainer,
  ShowDecimalsMenuItem,
} from 'spw-programming-projects/program-summary/components/styles';

interface DecimalMenuProps {
  onShowDecimals: (showDecimals: boolean) => void;
}

export const DecimalMenu: React.FunctionComponent<DecimalMenuProps> = ({
  onShowDecimals,
}: DecimalMenuProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showDecimals, setShowDecimals] = useState(false);

  return (
    <ShowDecimalsContainer flexGrow={1} justifyContent="flex-end">
      <MoreButton
        onClick={(e: React.BaseSyntheticEvent) => {
          e.stopPropagation();
          e.preventDefault();
          setAnchorEl(e.currentTarget);
        }}
        style={{ paddingTop: 0, paddingBottom: 0, height: '11px' }}
      >
        <MoreHorizIcon />
      </MoreButton>
      <Menu
        MenuListProps={{ disablePadding: true }}
        id="decimals-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(e: React.BaseSyntheticEvent) => {
          e.stopPropagation();
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock
      >
        <ShowDecimalsMenuItem
          onClick={() => {
            onShowDecimals(!showDecimals);
            setShowDecimals(!showDecimals);
            setAnchorEl(null);
          }}
        >
          {showDecimals ? 'Hide Decimals' : 'Show Decimals'}
        </ShowDecimalsMenuItem>
      </Menu>
    </ShowDecimalsContainer>
  );
};
